import { RenderEngine } from "./RenderEngine";
import { isMobile } from "react-device-detect";
import { ModelLoadController } from "./ModelLoad/ModelLoadController";
import { getWhiteLabel } from "../../whitelabel";
import { translate } from "./translateController";

export interface IScreenshot {
  blob:Blob;
  dataUrl:string;
}

export class ScreenshotController {
  constructor(private engine:RenderEngine, private modelLoadController:ModelLoadController) {
  }

  async makeScreenshot():Promise<IScreenshot[]> {
    const renderService = this.engine.engine.services.render;
    const renderController = renderService.renderController;

    const convertDataURIToBinaryBuffer = (dataURI:string) => {
      const BASE64_MARKER = ';base64,';
      const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      const base64 = dataURI.substring(base64Index);
      return Buffer.from(base64, 'base64');
    };

    await this.engine.engine.services.render.fadeOut(100, "#ffffff");
    
    // const origSize = new Vector2();
    // renderController.renderer.getSize(origSize);
    // renderController.resize(origSize.width, origSize.width);

    // let samples = 1;
    // const taa_webgl1 = renderService.settings.antialias.webgl1.temporal;
    // const taa_webgl2 = renderService.settings.antialias.webgl2.temporal;
    // const tsao = renderService.settings.sao;

    // // TODO: check whether the engine is running on WebGL1 or WebGL2.
    // if (taa_webgl1.enabled || taa_webgl2.enabled) {
    //   samples = Math.max(taa_webgl1.samples, taa_webgl2.samples);
    // }

    // // Assume we need 8 frames to get nicely sampled Temporal-SAO.
    // // We may want to further tweak this value in the future.
    // if (tsao.enabled && tsao.temporalFilter) {
    //   samples = Math.max(samples, 8);
    // }

    // // If we change crucial rendering paramters such as resolution, scene or camera,
    // // then the engine may invalidate the TAA history.
    // // We render multiple frames in that case to make sure the screenshot is fully sampled.
    // for (let i = 0; i < samples; i++) {
    //   renderController.render(0);
    // }
    renderController.render(0);

    // Screenshot without overlay
    const dataURL0 = renderController.renderer.domElement.toDataURL("image/jpeg");
    const blob0 = new Blob([convertDataURIToBinaryBuffer(dataURL0)], { type: "image/jpeg" });

    // Screenshot with overlay
    const image = await this.imageFromDataURL(dataURL0);
    const overlayCanvas = this.makeOverlay(image);
    const dataURL1 = overlayCanvas.toDataURL("image/jpeg");
    const blob1 = new Blob([convertDataURIToBinaryBuffer(dataURL1)], { type: "image/jpeg" });

    // renderController.resize(origSize.width, origSize.height);

    await this.engine.engine.services.render.fadeIn(300, "#ffffff");

    return Promise.resolve([
      {
        dataUrl: dataURL0,
        blob: blob0
      },
      {
        dataUrl: dataURL1,
        blob: blob1
      }
    ]);
  }

  private makeOverlay(image:HTMLImageElement):HTMLCanvasElement {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.style.width = `${image.width}`;
    canvas.style.height = `${image.height}`;

    const ctx = canvas.getContext("2d");

    // Screenshot layer
    ctx.drawImage(image, 0, 0);

    // Text layer
    const text0a = `${translate("id_my_next")} ${this.modelLoadController.getCurrentModelGroup().name}`;
    const text0b = this.modelLoadController.getModel().line;
    const text1 = getWhiteLabel().name;
    const dpr = window.devicePixelRatio * (isMobile ? 1 : 2);
    const verticalOffset = Math.max(0, (image.height - image.width) / 2) + 10 * dpr;
    ctx.fillStyle = "white";
    ctx.font = `bold ${30 * dpr}px Volks`;
    ctx.fillText(text0a, 10 * dpr, verticalOffset + 30 * dpr);
    if (text0b) {
      const text0aLen = ctx.measureText(text0a).width;
      ctx.font = `${15 * dpr}px Volks`;
      ctx.fillText(text0b, 14 * dpr + text0aLen, verticalOffset + 30 * dpr);
    }

    ctx.font = `${25 * dpr}px Volks`;
    ctx.fillText(text1, image.width - ctx.measureText(text1).width - 10 * dpr, image.height - verticalOffset);

    return canvas;
  }

  private async imageFromDataURL(dataURL:string):Promise<HTMLImageElement> {
    const image = new Image();
    return new Promise<HTMLImageElement>((resolve) => {
      image.onload = () => resolve(image);
      image.src = dataURL;
    })
  }
}